module.exports = __webpack_public_path__ + "img/transaction-failed.1b6a4e90.png";